var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSmeLogo = function SvgSmeLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "SME Invoicing Portal",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120.424
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5524",
    d: "M0 0h120v120.424H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10622",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 280307",
    d: "M67.208 43.251H33.286a2 2 0 0 0-2.12 2.12v48.763a2 2 0 0 0 2.12 2.12H67.42a2 2 0 0 0 2.12-2.12V45.371a2.492 2.492 0 0 0-2.332-2.12m-2.12 48.763H35.406V47.491H65.3v44.523Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 280308",
    d: "M76.961 33.498H43.039a2 2 0 0 0-2.12 2.12 2 2 0 0 0 2.12 2.12h32.014v46.643a2.12 2.12 0 0 0 4.24 0V35.618a2.492 2.492 0 0 0-2.332-2.12"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 280309",
    d: "M86.713 23.746H52.791a2 2 0 0 0-2.12 2.12 2 2 0 0 0 2.12 2.12h32.014v46.643a2.12 2.12 0 0 0 4.24 0V25.866a2.492 2.492 0 0 0-2.332-2.12"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 280310",
    d: "M40.495 86.501H60a2.12 2.12 0 0 0 0-4.24H40.495a2 2 0 0 0-2.12 2.12 2.125 2.125 0 0 0 2.12 2.12"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 280311",
    d: "M40.495 76.749H60a2.12 2.12 0 1 0 0-4.24H40.495a2 2 0 0 0-2.12 2.12 2.125 2.125 0 0 0 2.12 2.12"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 280312",
    d: "M40.495 66.996H60a2.12 2.12 0 0 0 0-4.24H40.495a2 2 0 0 0-2.12 2.12 2.125 2.125 0 0 0 2.12 2.12"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 280313",
    d: "M40.495 57.244H60a2.12 2.12 0 0 0 0-4.24H40.495a2 2 0 0 0-2.12 2.12 2.125 2.125 0 0 0 2.12 2.12"
  }))));
};
export default SvgSmeLogo;